import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { SelectFixedNoteComponent } from "src/app/inbox/order-summary/rx-form/select-fixed-note/select-fixed-note.component";
import { RxOptDisplayComponent } from "src/app/shared/components/rx-opt-display/rx-opt-display.component";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import {
  DrProfile,
  DrProfilePref,
  RXNote,
  RXOpt,
} from "src/app/shared/models/order.model";
import { rxOpt } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";

@Component({
  selector: "edit-profile-rx",
  templateUrl: "./edit-profile-rx.component.html",
  styleUrls: ["./edit-profile-rx.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RxOptDisplayComponent,
    FormsModule,
    SelectFixedNoteComponent,
    InputWrapComponent,
    TranslateModule,
  ],
})
export class EditProfileRxComponent {
  @Input() profile: DrProfile;
  @Input() lineType: "FIXED" | "REMOVABLE";

  options: RXOpt[] = [];
  addFixedNoteOpenSw: boolean;
  notes: RXNote[] = [];

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.options = this.store
      .selectSignal(rxOpt)()
      .filter(
        (r) =>
          (r.lineType == this.lineType ||
            (this.lineType == "FIXED" && r.lineType == "FORM")) &&
          r.drPrefSw &&
          (r.valueType == "LIST" ||
            r.valueType == "TEXT" ||
            r.valueType == "NUMBER")
      );

    this.options.forEach((o) => {
      let pref = this.profile.pref.find(
        (p) => p.prefType == "RX_OPT" && p.opt?.id == o.id
      );
      o.selectedValue = pref?.optValue;
    });

    this.notes = this.profile.pref
      .filter((p) => p.prefType == "NOTE" && p.noteLineType == this.lineType)
      .map((n) => {
        let note = new RXNote();
        note.presetNoteId = n.presetNoteId;
        note.text = n.note;
        return note;
      });

    if (this.notes.length == 0) {
      this.notes.push(new RXNote());
    }
  }

  save() {
    this.options.forEach((opt) => {
      let pref = this.profile.pref.find(
        (p) => p.prefType == "RX_OPT" && p.opt?.id == opt.id
      );

      if (opt.selectedValue) {
        if (pref) {
          pref.optValue = opt.selectedValue;
        } else {
          let newPref = new DrProfilePref();
          newPref.prefType = "RX_OPT";
          newPref.opt = opt;
          newPref.optValue = opt.selectedValue;
          this.profile.pref.push(newPref);
        }
      } else if (pref) {
        this.profile.pref.splice(this.profile.pref.indexOf(pref), 1);
      }
    });

    this.profile.pref = this.profile.pref.filter(
      (p) => !(p.prefType == "NOTE" && p.noteLineType == this.lineType)
    );

    this.notes.forEach((n) => {
      let newPref = new DrProfilePref();
      newPref.prefType = "NOTE";
      newPref.noteLineType = this.lineType;
      newPref.note = n.text;
      newPref.presetNoteId = n.presetNoteId;
      this.profile.pref.push(newPref);
    });
  }

  onFixedNoteClose(notes: RXNote[]) {
    this.addFixedNoteOpenSw = false;
    this.notes.push(...notes);
  }

  clearNote(note: RXNote) {
    this.notes.splice(this.notes.indexOf(note), 1);
  }
}
